import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SMSBasic } from 'src/app/models/turns-models/turns-sms-basic.model';
import { SmsService } from 'src/app/services/sms-service/smsservice';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-sms-sms-centers-card',
  templateUrl: './sms-sms-centers-card.component.html',
  styleUrls: ['./sms-sms-centers-card.component.scss']
})
export class SmsSmsCentersCardComponent implements OnInit, OnDestroy {

  @Input() sms: SMSBasic;
  centers;
  selectedCenters;
  updateSmsCentersSubscription: Subscription;

  constructor(private smsService: SmsService,
              private storageService: UserStorageService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
    this.centers = this.storageService.getCenterList();
  }

  public duallistboxOutputEventReceiver(selectedCenters) {
    const aux = new Array();
    for (const d of selectedCenters) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.updateSmsCenters(aux);
    }
  }

  public updateSmsCenters(centers) {
    this.updateSmsCentersSubscription = this.smsService.updateSmsCenters(this.sms.InternalId, this.filterCentersInternalIds(centers)).subscribe(
      (res) => {
        this.smsService.refreshSms();
        this.snackbarService.open('sms-page.snackbar messages.update sms success', 'success');
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }


  private filterCentersInternalIds(centers) {
    if (centers && (centers.length > 0)) {
      return centers.map(c => c.InternalId);
    } else {
      return [];
    }
  }

  ngOnDestroy() {
    if (this.updateSmsCentersSubscription) { this.updateSmsCentersSubscription.unsubscribe(); }
  }

}
